import { Alert } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';

const AlertVerification = () => {
    const userData = useSelector((state) => state.userData.userData);

    return (
        <>
            {userData && userData?.verification_status?.verificationStatus != "Verified" && (
                <Alert variant="standard" severity="warning">
                    Your profile is either incomplete or not yet verified. Please ensure all required details are filled out correctly and submit for verification to proceed.{' '}
                    <a href="/artist-verification" style={{ color: '#1976d2', textDecoration: 'underline', display: 'block' }}>
                        Click here to apply for account verification.
                    </a>
                </Alert>
            )
            }
        </>
    )
}

export default AlertVerification;